'use client';

import { use } from 'react';

import { AuthContext } from '../context/auth-context';

import type { AuthContextValue } from '../context/auth-context-value';

// ----------------------------------------------------------------------

/**
 * 반환 타입은 `../context/auth-context-value.ts`가 갖는다. 컨텍스트 기본값이
 * `undefined`라 널 가드를 거치면 TS 추론이 `never`가 되고, 그러면 TS 소비자가
 * 어떤 필드도 읽지 못한다. 아직 전부 선언되지는 않았고, 선언되지 않은 필드는
 * `unknown`이 된다(그쪽 머리말 참조).
 *
 * @returns {import('../context/auth-context-value').AuthContextValue}
 */
export function useAuthContext(): AuthContextValue {
  const context = use(AuthContext);

  if (!context) {
    throw new Error('useAuthContext: Context must be used inside AuthProvider');
  }

  return context;
}
